
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import ShareBtn from '@/components/ShareBtn.vue'
import Canvas from '@/components/Canvas.vue'
import ShareImg from '@/components/ShareImg.vue'

@Options({
  components: { ShareBtn, Canvas, ShareImg },
  data() {
    return {
      showShare: false,
      base64Src: "",
      showShareImg: false,
    }
  },
  computed: {
    ...mapState(["aid", "examAid" ,"userInfo", "myResult"])
  },
  methods: {
    saveResult() {
      if(!this.myResult.answerEncryption) return;
      this.$request(
        "/temporary/answer/save",
        {
          aid: this.examAid,
          userinfo: this.userInfo,
          answerEncryption: this.myResult.answerEncryption,
          teamId: this.examAid,
          teamType: "0"
        },
        "post"
      ).then((data: any) => {});
    },
    returnHome() {
      this.$router.replace('/examhome')
    },
    saveClick() {
      this.$common.pageLoading(true);
      this.showShare = true;
    },
    getCanvasPic(base64Src: string) {
      this.$common.pageLoaded();
      this.base64Src = base64Src;
      this.showShare = false;
      this.showShareImg = true;
    },
    closeShareImg() {
      this.showShareImg = false;
    },
  },
  mounted() {
    this.$common.pageLoaded();
    this.$common.track("load", "进入答题结果页");
    setTimeout(() => this.saveResult(), 300)
  }
})
export default class result extends Vue {}
